import { AccessDeniedErrorCode } from 'types';

/**
 * A 403 from the api's hasAppAccess gate: the account is signed in but may not
 * use the app. The legacy stack ends the session on it exactly as it did on the
 * 401 the gate used to answer; the AMS stack lets it surface to the caller.
 */
export const isAppAccessDenied = (status: number | undefined, body: unknown): boolean =>
  status === 403
  && (body as { errorCode?: unknown } | null | undefined)?.errorCode === AccessDeniedErrorCode.APP_ACCESS_DENIED;
